module.exports = __webpack_public_path__ + "static/media/10_of_clubs.669c20fc.svg";